import { TextField } from '@mui/material';

interface ResponseTypeFieldProps {
  value: string;
  setValue: (value: string) => void;
}

function ResponseTypeField({
  value,
  setValue,
}: ResponseTypeFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Response Type'
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ResponseTypeField;

